import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '闪职管理系统',
  splitMenus: true,
  pwa: false,
  logo: false, // 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg'
  iconfontUrl: '',
  token: {
    header: {
      colorBgHeader: '#000',
      colorHeaderTitle: '#fff',
      colorTextMenu: '#fff',
      colorTextMenuActive: '#000',
      colorBgMenuItemHover: '#ebf5ff',
      colorBgMenuItemSelected: '#ebf5ff',
      colorTextRightActionsItem: '#fff'
    }
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};
export default Settings;
